import Storage from '../../../storage/index';
import Config from '../../../config/index';

async function getStepCount(): Promise<number> {
    let result: number = 0;
    let paperId: number = Config.get({
        moduleName: 'base',
        key: 'paperId'
    });
    let allHistoryItems: HistoryItem[] = await Storage.get({
        tableName: 'history',
        query: {
            paperId
        }
    });

    return countCompute(allHistoryItems);
}

function countCompute(items: HistoryItem[]): number {
    let result: number = 0;
    let lastAction: string = '';

    items.forEach((item: HistoryItem): void => {
        if (item.actionId !== lastAction) {
            lastAction = item.actionId;
            result++;
        }
    });

    return result;
}

export {
    getStepCount
};
